<div class="edit-header">
    <div class="edit-header-info">
        <i class="betslip-icon theme-info" *msShowInEpcot="true" (click)="onInfoClick()"></i>
        <i class="betslip-icon theme-info-i" *msShowInEpcot="false" (click)="onInfoClick()"></i>
    </div>
    <div class="edit-header-title">{{ siteCore.betslip.editBet.header }}</div>
    <div class="edit-header-cancel" (click)="onCancelClick()">{{ siteCore.betslip.editBet.cancel }}</div>
</div>
